var React = require('react');

function Layers (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48 8L8 28L48 48L88 28L48 8Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 68L48 88L88 68","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8 48L48 68L88 48","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Layers.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Layers;

Layers.default = Layers;
